import { useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { useUserInfo } from "@redux/slices/userInfoSlice";

export const useGetCompanyImage = (image_type: string) => {
  const { settings } = useOrgSettingsSlice();
  const { user } = useUserInfo();

  return useQuery({
    queryKey: ["COMPANY_ORG_IMAGES"],
    enabled: user?.feature_settings?.org_home_page_banner,
    queryFn: () =>
      apiClient.get(Routes.COMPANY_IMAGES, {
        params: {
          image_purpose: image_type,
          company_org_id: user?.feature_settings?.white_label_homepage_banner
            ? user?.company_id
            : settings?.organization?.id,
          entity: user?.feature_settings?.white_label_homepage_banner
            ? "Company"
            : "Organization",
        },
      }),
  });
};
